import ProjectView from "../../project-view"
import ProjectViews from "../../project-views"
import ErrorProto from "../../../../gd/validation/error"
import ErrorFieldRequired from "../../../../gd/validation/error-field-required"
import EmbedUtils from "../../../../gd/utils/embed"
import ErrorFieldCustom from "../../../../gd/validation/error-field-custom"
import {EmbedType} from "../../../../gd/const/embed/embed-type"
import {ProjectView_Embed_AccessControl} from "./acl"
import {ProjectViewConfig} from "../../@types";

export default class ProjectView_Embed extends ProjectView {

    public embedCode        : string
    public defaultEmbedType : EmbedType

    constructor(viewConfig:ProjectViewConfig, projectViews:ProjectViews) {
        super(viewConfig, projectViews)

        this.name               = _.get(viewConfig, 'name', 'Embed')
        this.embedCode          = _.get(viewConfig, 'embedCode', '')
        this.defaultEmbedType   = _.get(viewConfig, 'defaultEmbedType', EmbedType.DEFAULT)

        this.hasTemplates       = false
    }

    get acl():ProjectView_Embed_AccessControl {

        if (!this._acl) {
            this._acl = new ProjectView_Embed_AccessControl(this)
        }

        return this._acl
    }

    get isLink():boolean {
        const embedCode = this.embedCode ? this.embedCode.trim() : ''
        return EmbedUtils.isLink(embedCode)
    }

    get isIFrame():boolean {
        const embedCode = this.embedCode ? this.embedCode.trim() : ''
        return EmbedUtils.isIFrame(embedCode)
    }

    edit() {
        // gd.modals.view.editEmbedView(this)
        gd.navigation.goTo(this.url + '/edit')
    }

    validate():ErrorProto[] | null  {
        const errors = super.validate() || []

        if (!this.name)         errors.push(new ErrorFieldRequired(gd.fields.projectView.name))
        // if (!this.embedCode)    errors.push(new ErrorFieldRequired(gd.fields.projectView.embedCode))

        const embedCode = this.embedCode ? this.embedCode.trim() : ''
        if (embedCode && !EmbedUtils.isLink(embedCode) && !EmbedUtils.isIFrame(embedCode)) {
            errors.push(new ErrorFieldCustom(gd.fields.projectView.embedCode, {message: 'Value should be a valid URL or an iframe'}))
        }

        if (_.isEmpty(errors)) return null
        else return errors
    }

    toJson() {
        const config: any = super.toJson()

        config.embedCode        = this.embedCode
        config.defaultEmbedType = this.defaultEmbedType

        return config
    }
}